"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var Checkbox = function (_a) {
    var _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.defaultChecked, defaultChecked = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.indeterminate, indeterminate = _f === void 0 ? false : _f, onChange = _a.onChange, _g = _a.description, description = _g === void 0 ? "" : _g;
    var _h = react_1.useState(checked), checkedState = _h[0], setCheckedState = _h[1];
    var defaultOnChange = function (e) {
        setCheckedState(e.target.checked);
        if (onChange) {
            onChange(e);
        }
    };
    return (react_1.default.createElement(antd_1.Checkbox, { autoFocus: autoFocus, checked: checkedState, defaultChecked: defaultChecked, disabled: disabled, indeterminate: indeterminate, onChange: defaultOnChange }, description));
};
exports.default = Checkbox;
